/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.addon.ChecksumStatus
*/
export var ChecksumStatus;
(function (ChecksumStatus) {
    ChecksumStatus["NONE"] = "NONE";
    ChecksumStatus["VERIFIED"] = "VERIFIED";
    ChecksumStatus["UNVERIFIED"] = "UNVERIFIED";
    ChecksumStatus["MISMATCH"] = "MISMATCH";
})(ChecksumStatus || (ChecksumStatus = {}));
//# sourceMappingURL=ChecksumStatus.js.map